<template>
  <div class="ticket-info-page">
    <Steps :active="0"></Steps>

    <Tabs current="member"></Tabs>

    <div class="blank" v-if="tableData.length===0">
      暂无数据
    </div>
    <div class="ticket-list" v-loading="loading">
      <div
        class="ticket-type box-shadow"
        v-for="(item, index) in tableData"
        :key="index">
        <div class="ticket-info">
          <p class="ticket-name">{{ item.name }}</p>
          <p class="ticket-price">
            <span class="current-price">￥{{ item.price }}</span>
          </p>
        </div>
        <div class="ticket-tags">
          <el-tag
            type="warning"
            v-for="(tag, tagIndex) in item.tags"
            :key="tagIndex">{{ tag.name }}</el-tag>
          <div class="ticket-btn" @click="showNotice(item)">立即预订</div>
        </div>
        <div class="ticket-extra">
          <p class="info-link" @click="showDetail(item)">会员详情 ></p>
          <!-- <span class="sold-count">已售 {{ item.total_sales_volume }}</span> -->
        </div>
      </div>
    </div>
    <el-pagination
      v-if="page.total > 10"
      style="margin: 20px auto;"
      :current-page.sync="page.pageNum"
      @current-change="getData"
      layout="prev, pager, next"
      :total="page.total">
    </el-pagination>
    <NoticeDialog ref="noticeDialog" :info="currentItem" jumpTo="memberOrder"></NoticeDialog>
    <DetailDialog ref="detailDialog" :info="currentItem"></DetailDialog>
  </div>
</template>

<script>
import { getTicketList } from '@/api'
import Steps from '@/components/Steps'
import PageTitle from '@/components/PageTitle'
import NoticeDialog from '@/components/NoticeDialog'
import DetailDialog from './MemberDetail'
import Tabs from '@/components/Tabs'

export default {
  components: {
    Tabs,
    Steps,
    PageTitle,
    NoticeDialog,
    DetailDialog
  },
  data () {
    return {
      loading: false,
      page: {
        type: 'MEMBER',
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      currentItem: {}
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.loading = true
      getTicketList(this.page).then(res => {
        this.page.total = res.data.extraInfo.total
        this.tableData = res.data.extraInfo.list
      }).finally(() => {
        this.loading = false
      })
    },
    showNotice (item) {
      this.currentItem = item
      this.$refs.noticeDialog.open()
    },
    showDetail (item) {
      this.currentItem = item
      this.$refs.detailDialog.open()
    },
    toPage (name) {
      this.$router.push({
        name
      })
    }
  }
}
</script>
<style lang="less" scoped>
.blank{
  background: #fff; padding: 20px; border-radius: 5px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); font-size: 16px; text-align: center; margin-top: 10px; color: #666;
}
</style>
